//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { MyAccountPersonalInformation } from './models/MyAccountPersonalInformation';
import type { MyAccountSetting } from './models/MyAccountSetting';
import { Utilities } from './Utilities';

export class MyAccountsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getSettings: (): string => {
            let clientRequestUrl = '/api/v3/my-accounts/settings';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getPersonalInformation: (): string => {
            let clientRequestUrl = '/api/v3/my-accounts/personal-information';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves all account settings for the current user.
     * @return OK
     */
    async getSettings(): Promise<MyAccountSetting> {
        const clientRequestUrl = this.baseUrl + this.routes.getSettings();

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<MyAccountSetting>(_response, false, []);
    }

    /**
     * Retrieves the personal information of the current user.
     * @return OK
     */
    async getPersonalInformation(): Promise<MyAccountPersonalInformation> {
        const clientRequestUrl = this.baseUrl + this.routes.getPersonalInformation();

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<MyAccountPersonalInformation>(_response, false, []);
    }
}
